"use strict";

import Filter from "./Filter.js";

export default class Filters {
    constructor(props) {
        this.data = props.map((item) => new Filter(item));
        this.totalSelected = 0;
        this.eventsSet = false;
    }
    init() {}

    set(object) {
        this.data = object.map((item) => new Filter(item));
    }

    get() {
        return this.data;
    }

    updateTotalSelected() {}

    renderList(searchManager) {
        const _this = this;
        const filtersMenu = document.querySelector("#filtersMenu");
        const filtersList = filtersMenu.querySelector("ul.nav");
        if (!this.eventsSet) {
            this.eventsSet = true;
            filtersMenu.querySelector(".reset").addEventListener("click", (event) => {
                _this.totalSelected = 0;
                _this.renderList(searchManager);
                filtersMenu.querySelector(".reset").style.display = "none";
                searchManager.resetSearchList("filters");
                searchManager.searchTracks();
            });
        }
        filtersList.textContent = "";
        this.data.map((filter) => filtersList.appendChild(filter.renderListItem(searchManager)));
        filtersList.querySelectorAll("input[type=checkbox]").forEach((item) => {
            item.addEventListener("click", (event) => {
                if (event.target.checked) {
                    _this.totalSelected++;
                } else {
                    // Already done by function to remove filter from searchbar
                    // _this.totalSelected--;
                }
                if (_this.totalSelected === 0) {
                    filtersMenu.querySelector(".reset").style.display = "none";
                } else {
                    filtersMenu.querySelector(".reset").style.display = "flex";
                }
                filtersMenu.querySelector(".apply-filters-container p").textContent = _this.totalSelected === 1 ? `1 filter selected` : `${_this.totalSelected} filters selected`;
            });
        });
    }

    renderHeaderList(category, elements) {
        const container = document.querySelector("#categoriesHeaderSection");
        this.data.filter((_filter) => _filter.data.Name === category && _filter.renderHeaderListItem(elements, container));
    }

    dispose() {
        this.data = [];
    }
}
